export default __webpack_public_path__ + "static/media/sx.02d41cbd.jpg";